import styled from "styled-components";

export const SearchInput = styled.input`
    width: 80%;
    padding: 12px 15px;
    border: 1px solid ${props => props.theme.colors.border};
    border-radius: 6px;
    font-size: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &:focus {
      border-color: ${props => props.theme.colors.focus};
      box-shadow: 0 0 5px ${props => props.theme.colors.focusRing};
      outline: none;
    }

    &:hover {
      border-color: ${props => props.theme.colors.primaryHover};
    }
`


export const SearchButton = styled.button`
  width: 20%;
  padding: 12px 20px;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.onColor};
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primaryHover};
  }

  &:disabled {
    background-color: ${props => props.theme.colors.secondary};
    cursor: not-allowed;
  }
`;